import { defineStore } from "pinia";
import { OFFER_TABS, OfferSingle } from "@/services/offers/OfferSingle";
import { IBrand } from "@/api/types/offers";
import { ref } from "vue";

export const useOfferDetailStore = defineStore("offerDetail", () => {
    const isUpdateOffer = ref<boolean>(false);
    const setIsUpdateOffer = (value: boolean) => {
        isUpdateOffer.value = value;
    };

    const isEditModeGoals = ref<boolean>(false);
    const setIsEditModeGoals = (value: boolean) => {
        isEditModeGoals.value = value;
    };
    const isCreateModeGoals = ref<boolean>(false);
    const setIsCreateModeGoals = (value: boolean) => {
        isCreateModeGoals.value = value;
    };
    const isUpdateGoals = ref<boolean>(false);
    const setIsUpdateGoals = (value: boolean) => {
        isUpdateGoals.value = value;
    };

    const activeEditId = ref<string>('');
    const setActiveEdit = (id: string) => {
        activeEditId.value = id;
    };
    const resetActiveEdit = () => {
        activeEditId.value = '';
    };

    const targetTab = ref<OFFER_TABS | ''>('');
    const changeOfferTab = (tab: OFFER_TABS | '') => {
        targetTab.value = tab;
    };

    const brands = ref<IBrand[]>([]);
    const setBrands = (newBrands: IBrand[]) => {
        brands.value = newBrands;
    };

    const prepareTrackingDomain = (offer: OfferSingle | null): string => {
        if (offer) {
            if (offer.tracking_domain?.domain) {
                return offer.tracking_domain.domain;
            }

            if (offer.departments.length) {
                switch (offer.departments[0].name) {
                case 'Мир': return 'go.leadgid.com';
                case 'РФ': return 'go.leadgid.ru';
                case 'Казахстан': return 'go.leadgid.com';
                default: return 'go.leadgid.ru';
                }
            }
        }

        return 'go.leadgid.ru';
    };

    return {
        isUpdateOffer,
        setIsUpdateOffer,
        isEditModeGoals,
        setIsEditModeGoals,
        isCreateModeGoals,
        setIsCreateModeGoals,
        isUpdateGoals,
        setIsUpdateGoals,
        activeEditId,
        setActiveEdit,
        resetActiveEdit,
        targetTab,
        changeOfferTab,
        brands,
        setBrands,
        prepareTrackingDomain,
    };
});
